<template>
  <scout-form
    :is-modified="!!from || !!to"
    label="最終ログイン時期の指定"
  >
    <term-select
      :from="from"
      :to="to"
      no-option
      @update:from="$emit('update:from', $event)"
      @update:to="$emit('update:to', $event)"
    />
    <span class="boss-annotation-text">
      ※会員がtypeを利用した最新日時を指定する項目です。（ログイン中）
    </span>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import TermSelect from '@/components/atoms/TermSelect'

export default {
  components: {
    ScoutForm,
    TermSelect
  },
  props: {
    from: {
      required: true,
      type: String
    },
    to: {
      required: true,
      type: String
    }
  }
}
</script>
